import React from 'react'
import DefaultFrame from '../components/frame/DefaultFrame'
import BackLink from '../components/ui/navigation/BackLink'

function Settings() {
    return (
        <DefaultFrame>
            <div className="scene--base scene__settings">
                <div className="scene--title">
                    <BackLink>
                        <button className="backLink--title" type="button">Back</button>
                    </BackLink>
                    <h1>Settings</h1>
                </div>
                <h2>Here be Dragons...</h2>
                <ul>
                    <li>Difficulty</li>
                    <li>Language</li>
                    <li>Link Account to Social Media</li>
                    <li>Link Account to OpenID</li>
                </ul>
            </div>
        </DefaultFrame>
    )
}

export default Settings
